import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_DOCUMENT} from '../../constants';

export default {
  id: 'QUITUS',
  title: 'Was ist der Standard Ordner?',
  description: '',
  categories: [CONTENT_CATEGORY_DOCUMENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Der Ordner stellt einen Gesamtüberblick der allgemein üblichen, zu erbringenden Dokumente dar, nach Geschäftsbereich und entsprechenden Erfordernissen aufgebaut und sortiert.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Ihre Kunden haben einen umfassenden Überblick zum Stand Ihrer Dokumente, der letztlich einen reibungsfreien, unbürokratischen Ablauf des Geschäftsverkehrs sichert.'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_QUITUS/DE_QUITUS_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Um die Ordnerübersicht herunterzuladen, gehen Sie auf die Registerkarte "Dokument" und klicken Sie auf "Nachweisstatus herunterladen".'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}de/DE_QUITUS/DE_QUITUS_2.png`
  }]
};
